import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThongkeService {

  constructor(private httpClient: HttpClient) { }

  thongketheonam(year: number) {
    return this.httpClient.get('/api/ThongKe/ThongKeTheoNam?year=' + year);
  }

  thongketheothang(month: number, year: number) {
    return this.httpClient.get('/api/ThongKe/ThongKeTheoThang?year=' + year + '&month=' + month);
  }
}
